__webpack_require__.p = "https://catalog.bosslogics.live/";